"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _MenuItem = _interopRequireDefault(require("../../MenuItem"));
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '&&': {
        height: '100%',
        padding: theme.spacing(0, 2, 0, 1.5)
      }
    }
  };
});
var GroupLabel = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
    value = _ref.value;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    classes: {
      root: classes.root
    },
    disableGutters: true,
    label: true,
    ref: ref,
    value: value
  }, children);
});
GroupLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string
} : {};
var _default = GroupLabel;
exports["default"] = _default;